import { z } from 'zod';

export const DocumentStatusTypeZod = z.union([
    z.literal('Deleted'),
    z.literal('In_Progress'),
    z.literal('Executed'),
    z.literal('Revoked'),
    z.literal('Generated'),
]);
export type DocumentStatusType = z.infer<typeof DocumentStatusTypeZod>;
